import { Add } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { ContentBox } from '@/components/shared/content-box';
import { Icon } from '@/components/shared/icon';

export const EmptyState = () => {
  const navigate = useNavigate();
  const startNewPlan = () => navigate('/pdi/planos/novo');

  return (
    <ContentBox maxWidth={{ md: '60%' }} gap={3} p={4}>
      <Icon name="map" size={48} />
      <Stack gap={2}>
        <Typography variant="h2" color="primary.dark" fontWeight="semibold">
          Crie um plano sob medida para o seu desenvolvimento
        </Typography>
        <Typography>
          Declare seus objetivos e a duração desejada para que nossa
          Inteligência Artificial recomende um plano estruturado com as
          atividades e conteúdos certos para desenvolver as habilidades que você
          precisa.
        </Typography>
        <Typography>
          Você pode seguir a sugestão, adaptá-la como preferir ou começar do
          zero.
        </Typography>
        <Typography>
          Com o plano criado, registre seu progresso e acompanhe sua evolução de
          forma simples e organizada.
        </Typography>
      </Stack>

      <Button
        variant="contained"
        startIcon={<Add />}
        sx={{ alignSelf: 'flex-start' }}
        onClick={startNewPlan}
      >
        Novo plano
      </Button>
    </ContentBox>
  );
};
